import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { BLOG_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import BlogsListContainer from './containers/blogs-list/blogs-list.container';
import EditBlogContainer from './containers/edit-blog/edit-blog.container';
/**
 * function BlogModule components
 */
export const BlogModule: React.FC = () => {
  return (
    <>
      <Route exact path={BLOG_ROUTES.FULL_PATH}>
        <Redirect to={(BLOG_ROUTES.CHILDREN as RouteConfig).LIST.FULL_PATH} />
      </Route>
      <Route
        path={(BLOG_ROUTES.CHILDREN as RouteConfig).LIST.FULL_PATH}
        component={BlogsListContainer}
      />
      <Route
        path={(BLOG_ROUTES.CHILDREN as RouteConfig).NEW.FULL_PATH}
        component={EditBlogContainer}
      />
      <Route
        path={(BLOG_ROUTES.CHILDREN as RouteConfig).EDIT.FULL_PATH}
        component={EditBlogContainer}
      />
    </>
  );
};
